import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import { getAlternateLanguageLinks, nl2br, getBaseName } from '../common/Utils';
import moment from 'moment';
import parse  from 'html-react-parser';

function stripHtml(value) {
    if (!value) {
        return '';
    }

    return value
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, ' ')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, ' ')
        .replace(/==IMG_\d+_TO_BE_INSERTED==/g, ' ')
        .replace(/<[^>]+>/g, ' ')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, ' ')
        .trim();
}

function truncateText(value, maxLength) {
    if (!value || value.length <= maxLength) {
        return value || '';
    }

    return `${value.substring(0, maxLength - 1).trim()}…`;
}


class NewsContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: null
        };
    }

    async loadData() {
        const lang = this.props.match.params.lang;

        const apiParams = new URLSearchParams({
            refNo: this.props.refNo,
            lang: lang
        });
        const apiUrl = `${getBaseName()}/api/news/content?${apiParams.toString()}`;

        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }

        try {            
            const response = await fetch(apiUrl,options);
            if (response.status === 200) {
                const result = await response.json();

                this.setState({
                    news: result
                });
            } else {
                this.props.history.push(`/gateway/${lang}/error`);     
            }
        } catch (error) {
            console.log(error);
        }
    }

    componentDidMount() {
        this.loadData();

        if (typeof window.writeMenu === "function") { 
            window.writeMenu();
        }


    }

    render() {
        const { t } = this.props;
        const { news } = this.state;
        const lang = this.props.match.params.lang;
        const REACT_APP_APPS_DOMAIN = `${process.env['REACT_APP_APPS_DOMAIN']}`;
        
        const gaScript = `
            var _gaq = _gaq || []; 
            _gaq.push(['_setAccount', '${process.env['REACT_APP_GA_ID']}']); 
            _gaq.push(['_setDomainName', '${REACT_APP_APPS_DOMAIN}']); 
            _gaq.push(['_trackPageview']); 
            
            (function () { 
            var ga = document.createElement('script'); ga.type = 'text/javascript'; ga.async = true; 
            ga.src = ('https:' == document.location.protocol ? 'https://ssl' : 'http://www') + '.google-analytics.com/ga.js'; 
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ga, s); 
            })();
        `;

        const ga4ScriptId = `${process.env['REACT_APP_GA4_ID']}`;

        const ga4Script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
        
            gtag('config', '${process.env['REACT_APP_GA4_ID']}');      
        `;

        if (news === null) {
            return (
                <div>Loading News Content...</div>
            );
        } else {
            const plainTitle = stripHtml(news.title);
            const plainBody = stripHtml(news.html);
            const metaDescription = truncateText(plainBody || plainTitle, 160);
            const canonicalUrl = `${window.location.origin}${window.location.pathname}${window.location.search}`;
            const alternateLanguageLinks = getAlternateLanguageLinks();
            const inLanguage = lang === 'TC' ? 'zh-Hant-HK' : 'en-HK';
            const locale = lang === 'TC' ? 'zh_HK' : 'en_HK';
            const defaultImageUrl = 'https://www.sfc.hk/assets/images/common/SFC_Logo_Abbreviation_A3_RGB.png?2';
            const imageUrls = (news.imageList || []).map((image) =>
                `${window.location.origin}${process.env['PUBLIC_URL']}/api/news/openImage?refNo=${news.newsRefNo}&lang=${lang}&image=${image.imageRefNo}`
            );
            const imageUrl = imageUrls.length > 0 ? imageUrls[0] : defaultImageUrl;
            const publishedTime = moment(news.issueDate, "YYYY-MM-DDTHH:mm:ss").toISOString();
            const modifiedTime = moment(news.modificationTime, "YYYY-MM-DDTHH:mm:ss").toISOString();
            const sfcOrganization = {
                '@type': 'Organization',
                name: 'Securities and Futures Commission',
                url: `https://${REACT_APP_APPS_DOMAIN}`
            };
            const structuredData = {
                '@context': 'https://schema.org',
                '@type': 'NewsArticle',
                headline: plainTitle,
                description: metaDescription,
                articleBody: plainBody,
                text: plainBody,
                datePublished: publishedTime,
                dateModified: modifiedTime,
                inLanguage,
                identifier: news.newsRefNo,
                isAccessibleForFree: true,
                mainEntityOfPage: canonicalUrl,
                url: canonicalUrl,
                author: sfcOrganization,
                publisher: sfcOrganization
            };

            structuredData.image = imageUrls.length > 0 ? imageUrls : [defaultImageUrl];
            structuredData.thumbnailUrl = imageUrl;

            let isImgHandledMap = {};
            let imgElementWithoutPlaceholderList = [];

            function getImgPlaceholder(imageRefNo){
                return "==IMG_" + (parseInt(imageRefNo) + 1) + "_TO_BE_INSERTED=="
            }

            function createImgElement(imgRefNo,caption,newsRefNo){
                return (<div key={imgRefNo} className="newsImageWrapper">
                            <a href={`${process.env['PUBLIC_URL']}/api/news/openImage?refNo=${newsRefNo}&lang=${lang}&image=${imgRefNo}`} target="_blank">
                                <img className="newsImage" src={`${process.env['PUBLIC_URL']}/api/news/openImage?refNo=${newsRefNo}&lang=${lang}&image=${imgRefNo}`}></img>
                            </a>
                            <p>{caption}</p>
                            <br />
                        </div>)
                
            }

            const parserOptions = {
              replace: (element) => {
                  const { data } = element

                  for (let i = 0; i < news?.imageList.length; i++) {
                      let tempImg = news?.imageList[i]

                      let tempImgPlaceholder = getImgPlaceholder(tempImg.imageRefNo)
                      let tempImageRefNo = tempImg.imageRefNo
                      let tempImgCaption = tempImg.caption
                      let tempNewsRefNo = news.newsRefNo

                      if (tempImg && data) {
                          if(data.indexOf(tempImgPlaceholder) > -1){
                            isImgHandledMap[tempImgPlaceholder] = true
                            return createImgElement(tempImageRefNo,tempImgCaption,tempNewsRefNo)
                          }
                      }
                  }
              },
            };

            let parsedElement = parse(news.html, parserOptions);

            imgElementWithoutPlaceholderList = news?.imageList
            ?.filter((img) => {
              const tempImgPlaceholder = getImgPlaceholder(img.imageRefNo)
              return !isImgHandledMap[tempImgPlaceholder]
            })
            .map((img) => createImgElement(img.imageRefNo,img.caption,news.newsRefNo))


            const footerNotes = [];
            if (news.maskedFooterType != null) {
                footerNotes.push(
                    <div>
                        <p><small>{t(`content.footnotes.${news.maskedFooterType}`)}</small></p>
                    </div>
                );
            }
            return (
                <div>
                    <Helmet>
                        <title>{plainTitle} | {t('common:sfc')}</title>
                        <meta name='description' content={metaDescription}></meta>
                        <meta name='date' content={t('common:date.metaformatter',{date:moment(news.issueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}></meta>
                        <meta name='robots' content='index,follow,max-image-preview:large'></meta>
                        <link rel='canonical' href={canonicalUrl}></link>
                        {alternateLanguageLinks.map((alternateLanguageLink) => (
                            <link key={alternateLanguageLink.hrefLang} rel='alternate' hreflang={alternateLanguageLink.hrefLang} href={alternateLanguageLink.href}></link>
                        ))}
                        <meta property='og:type' content='article'></meta>
                        <meta property='og:site_name' content={t('common:sfc')}></meta>
                        <meta property='og:locale' content={locale}></meta>
                        <meta property='og:title' content={plainTitle}></meta>
                        <meta property='og:description' content={metaDescription}></meta>
                        <meta property='og:url' content={canonicalUrl}></meta>
                        {imageUrl && <meta property='og:image' content={imageUrl}></meta>}
                        <meta property='article:published_time' content={publishedTime}></meta>
                        <meta property='article:modified_time' content={modifiedTime}></meta>
                        <meta name='twitter:card' content={imageUrl ? 'summary_large_image' : 'summary'}></meta>
                        <meta name='twitter:title' content={plainTitle}></meta>
                        <meta name='twitter:description' content={metaDescription}></meta>
                        {imageUrl && <meta name='twitter:image' content={imageUrl}></meta>}
                        <script type='application/ld+json'>{JSON.stringify(structuredData)}</script>
                        <script>{gaScript}</script>
                        <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4ScriptId}`}></script>
                        <script>{ga4Script}</script>
                    </Helmet>
                    <div>
                        <h1>{parse(news.title, {})}</h1>
                    </div>
                    <div>
                        <p><small>
                            {t('common:date.formatter',{date: moment(news.issueDate, "YYYY-MM-DDTHH:mm:ss").toDate()})}

                        </small></p>
                    </div>
                    <br/><br/>

                        <div className="newsc">
                            {parsedElement}
                            {imgElementWithoutPlaceholderList.length > 0 && imgElementWithoutPlaceholderList}
                        </div>

                    {news.appendixDocList.map((appendix) =>
                        <Link key={appendix.refNo} to={`openAppendix?refNo=${news.newsRefNo}&appendix=${appendix.refNo}`} target="_blank">
                            <br/>
                            {appendix.caption}
                        </Link>
                    )}
                    <br/>
                    {footerNotes}
                    <br/>
                    <div>
                        <p>
                            <small>{t("content.label.lastUpdateDate",{date: moment(news.modificationTime, "YYYY-MM-DDTHH:mm:ss").toDate()})}</small>

                        </p>
                    </div>

                </div>
            );
        }
    }
}

export default withRouter(withTranslation()(NewsContent));